
const AgeGroupSchedule = () => {
  const ageGroups = [
    {
      title: 'Little Kickers (Ages 3-5)',
      description: 'Fun-focused introduction to soccer with basic skills and coordination',
      image: 'https://public.readdy.ai/ai/img_res/6aba307b2b494d5a6a24438544b42d20.jpg',
      sessions: [
        { day: 'Saturday', time: '9:00 AM - 10:00 AM', duration: '60 min' },
        { day: 'Sunday', time: '10:00 AM - 11:00 AM', duration: '60 min' }
      ],
      features: ['Small group sizes (max 8)', 'Parent participation welcome', 'Focus on fun and movement', 'Basic ball skills']
    },
    {
      title: 'Young Players (Ages 6-8)',
      description: 'Building fundamental skills with structured play and teamwork',
      image: 'https://readdy.ai/api/search-image?query=Children%20aged%206-8%20practicing%20soccer%20fundamentals%20wearing%20purple%20NextZen%20Soccer%20Academy%20jerseys%20with%20proper%20equipment%20on%20a%20well-maintained%20grass%20field%20showing%20focused%20training%20drills%20and%20skill%20development%20activities%2C%20purple%20team%20uniforms%2C%20professional%20coaching&width=400&height=300&seq=young-players-purple&orientation=landscape',
      sessions: [
        { day: 'Monday', time: '4:00 PM - 5:00 PM', duration: '60 min' },
        { day: 'Wednesday', time: '4:00 PM - 5:00 PM', duration: '60 min' },
        { day: 'Friday', time: '4:00 PM - 5:00 PM', duration: '60 min' }
      ],
      features: ['Technical skill development', 'Small-sided games', 'Positive reinforcement', 'Individual attention']
    },
    {
      title: 'Development (Ages 9-13)',
      description: 'Advanced skill building with tactical awareness and competitive play',
      image: 'https://readdy.ai/api/search-image?query=Pre-teen%20soccer%20players%20aged%209-12%20wearing%20purple%20NextZen%20Soccer%20Academy%20jerseys%20engaged%20in%20structured%20training%20drills%20with%20professional%20coaching%20showing%20tactical%20development%20and%20competitive%20spirit%20on%20a%20regulation%20soccer%20field%2C%20purple%20team%20uniforms&width=400&height=300&seq=development-purple&orientation=landscape',
      sessions: [
        { day: 'Monday', time: '5:15 PM - 6:30 PM', duration: '75 min' },
        { day: 'Tuesday', time: '5:15 PM - 6:30 PM', duration: '75 min' },
        { day: 'Thursday', time: '5:15 PM - 6:30 PM', duration: '75 min' },
        { day: 'Saturday', time: '10:15 AM - 11:30 AM', duration: '75 min' }
      ],
      features: ['Tactical understanding', 'Position-specific training', 'Competitive matches', 'Leadership development']
    },
    {
      title: 'Elite Training (Ages 14-17)',
      description: 'High-performance training for serious young athletes',
      image: 'https://readdy.ai/api/search-image?query=Teenage%20soccer%20players%20aged%2013-16%20wearing%20purple%20NextZen%20Soccer%20Academy%20jerseys%20in%20intensive%20training%20session%20with%20advanced%20drills%20and%20professional%20coaching%20equipment%20showing%20elite%20level%20skill%20development%20and%20athletic%20performance%2C%20purple%20team%20uniforms&width=400&height=300&seq=elite-training-purple&orientation=landscape',
      sessions: [
        { day: 'Monday', time: '6:45 PM - 8:00 PM', duration: '75 min' },
        { day: 'Tuesday', time: '6:45 PM - 8:00 PM', duration: '75 min' },
        { day: 'Wednesday', time: '6:45 PM - 8:00 PM', duration: '75 min' },
        { day: 'Thursday', time: '6:45 PM - 8:00 PM', duration: '75 min' },
        { day: 'Saturday', time: '11:45 AM - 1:00 PM', duration: '75 min' }
      ],
      features: ['Advanced tactics', 'Fitness conditioning', 'Mental preparation', 'College prep guidance']
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Training by Age Group</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our age-appropriate programs ensure every player receives training tailored to their developmental stage and skill level.
          </p>
        </div>

        <div className="space-y-12">
          {ageGroups.map((group, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              <div className="lg:w-1/2">
                <img 
                  src={group.image} 
                  alt={group.title}
                  className="w-full h-80 object-cover rounded-xl shadow-lg"
                />
              </div>
              <div className="lg:w-1/2 space-y-6">
                <div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-3">{group.title}</h3>
                  <p className="text-lg text-gray-600">{group.description}</p>
                </div>

                <div className="bg-gray-50 rounded-lg p-6">
                  <h4 className="text-xl font-semibold text-gray-900 mb-4">Session Times</h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {group.sessions.map((session, sessionIndex) => (
                      <div key={sessionIndex} className="bg-white rounded-lg p-4 border border-gray-200">
                        <div className="font-semibold text-gray-900">{session.day}</div>
                        <div className="text-blue-600">{session.time}</div>
                        <div className="text-sm text-gray-500">{session.duration}</div>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <h4 className="text-xl font-semibold text-gray-900 mb-3">Program Features</h4>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {group.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center space-x-2">
                        <i className="ri-check-line text-green-600 text-lg"></i>
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AgeGroupSchedule;
